import { render } from "./UiCheck.vue?vue&type=template&id=226ba495&scoped=true"
import script from "./UiCheck.vue?vue&type=script&lang=js"
export * from "./UiCheck.vue?vue&type=script&lang=js"

import "./UiCheck.vue?vue&type=style&index=0&id=226ba495&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226ba495"]])

export default __exports__